module.exports = __webpack_public_path__ + "img/nature11.9e700629.jpg";